import {ApiRequestType, onRequestFailure, onRequestSuccess} from "store/middlewares/apiMiddleware";

interface LinkAPISearchDataType {
  event_id: string,
}

interface LinkAPIDeleteDataType {
  id: number,
}

interface LinkAPIEditDataType {
  id: number,
  url: string|null,
  blocked: boolean,
}

export const LinkAPI = {

  edit: function (data: LinkAPIEditDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/link`,
      method: 'PUT',
      data: data,
      slice: 'link',
      action: 'edit',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  delete: function (data: LinkAPIDeleteDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/link`,
      method: 'DELETE',
      data: data,
      slice: 'link',
      action: 'delete',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  search: function (data: LinkAPISearchDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/links`,
      method: 'POST',
      data: data,
      slice: 'link',
      action: 'search',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

}